













































import { Member } from "@/api/models";
import {
  notEmptyString,
  validEmail,
} from "@/api/validators";
import { bus } from "@/main";
import { SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {},
  filters: {},
})
export default class MemberField extends Vue {
  @Prop({ default: "Link" }) label: string;
  @Prop({ default: 0 }) index: number;
  @Prop({ default: () => new Member() }) member: Member;
  @State("submission") submission: SubmissionState;

  displayName = "";
  identifier = "";
  description = "";

  emailError = false;

  created() {
    this.sync();
  }

  sync() {
    this.displayName = this.member.displayName;
    this.identifier = this.member.identifier;
    this.description = this.member.description;
  }

  update() {
    const identifier = this.isMatched ? this.member.identifier : this.identifier;
    const memberObj = {
      identifier,
      displayName: this.displayName,
      description: this.description,
      submission: this.member.submission,
      slug: this.member.slug,
      isLead: this.member.isLead,
    };
    bus.$emit('update-member', {
      index: this.index,
      member: memberObj
    })
  }

  getNameField(name: string) {
    return ['member', name, this.index]
      .join("_")
      .replace(/\./g, "_");
  }

  get genNameDisplayName() {
    return this.getNameField("display-name");
  }

  get genNameIdentifier() {
    return this.getNameField("identifier");
  }

  get genNameDescription() {
    return this.getNameField("description");
  }

    get hasDisplayName() {
    return notEmptyString(this.displayName);
  }

  get isMatched() {
    return this.member.hasSubmission;
  }

  get emailPlaceholder(): string {
    return `Student's RCA Email`;
  }

  get displayNamePlaceholder(): string {
    return `Student's display name`;
  }

  get displayNameLabel(): string {
    return `Display name`;
  }

  get extraInfo(): string {
    return this.isMatched ? `slug: ${this.member.slug}` : ``;
  }

  get highlightMatch() {
    return this.isMatched && this.member.identifier.toLowerCase() === this.identifier.toLowerCase();
  }

  get nameDisabled() {
    return notEmptyString(this.member.identifier) && this.member.isLead;
  }

  validate() {
    this.emailError = false;
    if (notEmptyString(this.identifier)) {
      this.emailError = validEmail(this.identifier);
    }
  }

  fieldClasses(key = "") {
    const cls = [this.fieldClass(key)];
    if ((key === "identifier" && notEmptyString(this.displayName))) {
      cls.push("required");
    }
    return cls;
  }

  fieldClass(key = "") {
    switch (key) {
      case "title":
        return this.emailError ? "error" : "ok";
      case "url":
        return this.hasDisplayName ? "error" : "ok";
      default:
        return "ok";
    }
  }

  @Watch("displayName")
  changeDisplayName() {
    this.validate();
    this.update();
  }
  @Watch("identifier")
  changeIdentifier() {
    this.validate();
    this.update();
  }
  @Watch("description")
  changeDescription() {
    this.update();
  }

  deleteItem() {
    if (this.index > 0) {
    bus.$emit("delete-member", {
      index: this.index,
      });
    } else {
      this.displayName = "";
      this.identifier = "";
      this.description = "";
    }
  }
}
